import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const ChildrenSchoolAttendanceComparisonMonthly = () => {
    const { chartData } = useConditionalityChartsDataContext();

    const rawData = chartData?.childrenSchoolAttendanceComparisonMonth || [];

    const series = [
        {
            name: 'Presentes',
            data: rawData?.map(item => item.attended)
        },
        {
            name: 'Diferença',
            data: rawData?.map(item => item.difference)
        },
        {
            name: 'Total',
            data: rawData?.map(item => item.total)
        }
    ];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Comparação de Frequência Escolar (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
            showDataLabels={false}
        />
    );
};